/**
* Image Marquee JS
* -----------------------------------------------------------------------------
*
* All the JS for the Image Marquee component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'image-marquee',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.splide.splide-image' ).length ) {
        $( '.splide.splide-image' ).each( function( index, element ) {
          new Splide( $( element )[0], {
            type: 'loop',
            focus: 'center',
            arrows: false,
            pagination: false,
            gap: '2rem',
            speed: 400,
            autoWidth: true,
            breakpoints: {
            },
          } ).mount( {AutoScroll} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'image-marquee', COMPONENT );
} )( app );
